var _excluded = ["chinaLocalization"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'researcher';
import withRouter from 'shared/helper/with-router';
import { getChinaLocalization } from 'shared/account/reducer';
import chinaNavbarLinks from '../../config/chinaNavbarLinks';
import rowNavbarLinks from '../../config/rowNavbarLinks';
import HeaderChina from './HeaderChina';
import HeaderRow from './HeaderRow';
var getHeaderLinks = function getHeaderLinks(application, localization) {
  if (localization) {
    return chinaNavbarLinks(application.siteLanguage);
  }
  if (!localization) {
    return rowNavbarLinks(application.siteLanguage);
  }
  return application.config.links.header[application.siteLanguage] || application.config.links.header.en;
};
var HeaderContainer = function HeaderContainer(_ref) {
  var chinaLocalization = _ref.chinaLocalization,
    props = _objectWithoutProperties(_ref, _excluded);
  var TopNavigation = chinaLocalization ? HeaderChina : HeaderRow;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(TopNavigation, props);
};
var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var application = _ref2.application,
    user = _ref2.user;
  var location = _ref3.location;
  return {
    chinaLocalization: getChinaLocalization({
      application: application
    }),
    digitalTranslationsEnabled: application.allowsDigitalTranslations,
    headerLinks: getHeaderLinks(application, !!getChinaLocalization({
      application: application
    })),
    path: location.pathname,
    siteLanguage: application.siteLanguage,
    siteLanguages: application.config.siteLanguages,
    translationContext: application.translationContext,
    user: user,
    website: application.config.website[application.siteLanguage] || application.config.website.default
  };
};
var mapDispatchToProps = {
  updateSiteLanguage: actions.updateSiteLanguage
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderContainer));